import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const BANNER_CONTEXT_SYMBOL = Symbol();
const useBanner = ()=>useImmutableContext(BANNER_CONTEXT_SYMBOL);
const useBannerProvider = (...args)=>useImmutableContextProvider(BANNER_CONTEXT_SYMBOL, ...args);
export { useBanner, useBannerProvider };
